import {disPatchError} from "../utils"
import {GET_SYSTEM_FILE_TYPES, GET_SYSTEM_FILES, RESET_ERRORS, UPDATE_SUCCESS, UPDATE_SYSTEM_FILE} from "../types";
import axios from "../../utils/apiClient";
import {TRACK_EVENTS, trackPendoEvent} from "../../utils/pendoTrack";

export const URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/system-file/";

  export const updateSystemFile = (fileType, file, fileName) => (dispatch) => {
    dispatch({ type: "TOGGLE_LOAD", payload: true });
    dispatch({ type: RESET_ERRORS });
    const sanitizedFileType = encodeURIComponent(fileType);
    const sanitizedFile = encodeURIComponent(file);
    const sanitizedFileName = encodeURIComponent(fileName);
    axios.post(`${URL}upload-file?fileType=${sanitizedFileType}`, sanitizedFile, {
        headers: {
          "Accept" : "application/json",
          "Content-Type": "application/octet-stream",
          "X-Filename" : sanitizedFileName
        },
      })
      .then((res) => {
        dispatch({
          type: UPDATE_SYSTEM_FILE,
          payload: res.data,
        });
        dispatch({
          type: UPDATE_SUCCESS,
          payload: "Successfully Updated",
        });
        trackPendoEvent(TRACK_EVENTS.ADMIN_SYSTEM_FILE_UPLOAD, {
          route: window?.location?.pathname,
          source_module: "systemFileActions.updateSystemFile",
          file_type: fileType
        });
      })
      .catch((err) => {
        disPatchError(err,dispatch);
      });
  };

    export const getFileTypes = (setFileType) => (dispatch) => {
        dispatch({ type: "TOGGLE_LOAD" });
        dispatch({ type: RESET_ERRORS });
        axios
            .get(`${URL}file-types`, {
                headers: {
                },
            })
            .then((res) => {
                dispatch({
                    type: GET_SYSTEM_FILE_TYPES,
                    payload: res.data,
                });
                setFileType(res.data[0].value);
            })
            .catch((err) => disPatchError(err, dispatch));
    };

    export const getFiles = (fileType) => (dispatch) => {
        dispatch({ type: "TOGGLE_LOAD" });
        dispatch({ type: RESET_ERRORS });
        const sanitizedFileType = encodeURIComponent(fileType);
        axios
            .get(`${URL}files?fileType=${sanitizedFileType}`, {
                headers: {
                },
            })
            .then((res) => {
                dispatch({
                    type: GET_SYSTEM_FILES,
                    payload: res.data,
                });
            })
            .catch((err) => disPatchError(err, dispatch));
    };
